import { useQuery } from '@tanstack/react-query';

import { getDataFile } from '../api/api';
import { SS_QUERY_KEY } from '../constants/constants';

export const useDataFileQuery = (sdkKey: string) => {
    const {
        data: dataFile,
        isLoading: isDataFileLoading,
        error: dataFileError,
    } = useQuery({
        queryKey: [SS_QUERY_KEY.OPTIMIZELY_DATAFILE, sdkKey],
        queryFn: async () => (await getDataFile(sdkKey)).data,
        gcTime: 0,
    });

    return {
        dataFile,
        isDataFileLoading,
        dataFileError,
    };
};
